import { DateTime } from 'luxon'
import { taskStatus } from '../containers/TaskList/constants'

export const setTaskStates = (task) => {
  if (
    [taskStatus.OPEN, taskStatus.REJECTED].includes(task.currentState) &&
    task.due &&
    DateTime.fromISO(task.due) < DateTime.now()
  ) {
    return { ...task, state: taskStatus.OVERDUE, dueDateMissed: true }
  }
  return { ...task, state: task.currentState }
}
